import { Injectable } from '@angular/core';
import { CanActivate, CanActivateFn } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { takeUntil } from 'rxjs';
import { CustomerIdService } from '../../feature/customerId/customer-id.service';
@Injectable({
  providedIn: 'root',
})
export class onlineOderingGuard {
  constructor(private custIDService: CustomerIdService, protected routingService: RoutingService) {}
  canActivate() {
    this.custIDService.onlineOrdering$.subscribe((x) => {
      if (x == false) {
        this.routingService.go({ cxRoute: 'home' });
      }
    });
  }
}
